var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeStatement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Contract_-_Flaticon-2_2_",
    "data-name": "Search results for Contract - Flaticon-2 (2)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9906",
    "data-name": "Path 9906",
    d: "M71.069,51.613a4.82,4.82,0,0,1,2.684.813l11.264,7.51a8.055,8.055,0,0,0,4.474,1.355H100V58.064H89.493a4.827,4.827,0,0,1-2.686-.813l-4.55-3.034V0H20.968V9.677H0V100H61.29V90.322H82.258V76.753c.1-.024.206-.032.308-.057l7.5-1.875a20.994,20.994,0,0,1,5.092-.628H100V70.968H95.161a24.259,24.259,0,0,0-5.874.723l-7.5,1.875a21.093,21.093,0,0,1-11.729-.45l-2.718-.906a24.184,24.184,0,0,0-7.66-1.242H45.6a4.845,4.845,0,0,1,4.839-4.839H68.184a4.826,4.826,0,0,0,.566-9.621l1.324-4.9ZM69.032,76.176a24.145,24.145,0,0,0,7.66,1.244c.783,0,1.563-.068,2.341-.143V87.1H61.29V81.821a5.818,5.818,0,0,0,1.24-2.3l1.321-4.892a20.818,20.818,0,0,1,2.463.642ZM60.619,74.23l-1.2,4.448a2.664,2.664,0,0,1-2.567,1.967h-.523a2.658,2.658,0,0,1-2.566-3.352l.837-3.1h5.079c.314,0,.628.024.942.037Zm-9.363-.037-.61,2.256a5.846,5.846,0,0,0,2.77,6.619l-.506,2.022,3.129.783.5-2h.31a5.858,5.858,0,0,0,1.214-.142V96.774H3.226V12.9H24.194V3.226H79.032V52.068l-3.489-2.326a8.051,8.051,0,0,0-4.474-1.355h-.124L77.658,23.55a5.888,5.888,0,0,0-5.681-7.421h-.523a5.9,5.9,0,0,0-5.681,4.35L61.29,37.069V9.677H27.419V12.9H58.065V48.387H54.728A7.976,7.976,0,0,0,49.937,50H33.871v3.226H46.548l-3.226,3.226H33.871v3.226H40.1l-2.7,2.695a5,5,0,0,0,5,8.361c0,.079-.024.154-.024.234A3.229,3.229,0,0,0,45.6,74.194ZM63.681,62.9H57.65l6.811-25.2,5.533,1.844ZM51.307,53.029a4.876,4.876,0,0,1,3.421-1.416H57.36l-1.316,4.868a7.991,7.991,0,0,0-5.4,2.332l-8.4,8.4a1.809,1.809,0,0,1-3.089-1.277,1.8,1.8,0,0,1,.531-1.279Zm1.613,8.065a4.86,4.86,0,0,1,2.213-1.242L54.308,62.9h-3.2ZM74.543,22.708l-1.975,7.308-5.533-1.844,1.852-6.851a2.666,2.666,0,0,1,2.567-1.967h.523a2.659,2.659,0,0,1,2.566,3.353Zm-8.35,8.584,5.533,1.844-.891,3.292L65.3,34.583Zm1.99,28.386a1.613,1.613,0,0,1,0,3.226H67.021l.873-3.226Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9907",
    "data-name": "Path 9907",
    d: "M73.935,80H32V96.129H73.935ZM70.71,92.9H35.226V83.226H70.71Zm0,0",
    transform: "translate(-25.548 -63.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9908",
    "data-name": "Path 9908",
    d: "M64,112h3.226v3.226H64Zm0,0",
    transform: "translate(-51.097 -89.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9909",
    "data-name": "Path 9909",
    d: "M96,112h3.226v3.226H96Zm0,0",
    transform: "translate(-76.645 -89.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9910",
    "data-name": "Path 9910",
    d: "M128,112h3.226v3.226H128Zm0,0",
    transform: "translate(-102.194 -89.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M160,112h3.226v3.226H160Zm0,0",
    transform: "translate(-127.742 -89.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9912",
    "data-name": "Path 9912",
    d: "M192,112h3.226v3.226H192Zm0,0",
    transform: "translate(-153.29 -89.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9913",
    "data-name": "Path 9913",
    d: "M51.355,217.677H48.129v6.452h-12.9v-12.9H44.9V208H32v19.355H51.355Zm0,0",
    transform: "translate(-25.548 -166.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9914",
    "data-name": "Path 9914",
    d: "M77.7,178.344,62.71,193.333l-2.085-2.085-2.281,2.281,4.366,4.366,17.269-17.269Zm0,0",
    transform: "translate(-46.581 -142.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9915",
    "data-name": "Path 9915",
    d: "M48.129,360.129h-12.9v-12.9H44.9V344H32v19.355H51.355v-9.677H48.129Zm0,0",
    transform: "translate(-25.548 -274.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9916",
    "data-name": "Path 9916",
    d: "M60.625,327.247l-2.281,2.281,4.366,4.366,17.269-17.269L77.7,314.344,62.71,329.333Zm0,0",
    transform: "translate(-46.581 -250.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9917",
    "data-name": "Path 9917",
    d: "M256,440h3.226v3.226H256Zm0,0",
    transform: "translate(-204.387 -351.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9918",
    "data-name": "Path 9918",
    d: "M152,440h17.742v3.226H152Zm0,0",
    transform: "translate(-121.355 -351.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9919",
    "data-name": "Path 9919",
    d: "M168,216h20.968v3.226H168Zm0,0",
    transform: "translate(-134.129 -172.452)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStatement);
export default __webpack_public_path__ + "static/media/changeStatement.db36ecb974b69d0e9d36deb107e5c2f5.svg";
export { ForwardRef as ReactComponent };